//Renders header with access token.
export default function AuthHeader() {
    const token = sessionStorage.getItem("token");
    if (typeof token !== 'undefined') {
        return { 'Authorization': `Bearer ${token}` };
    } else {
        return null;
    }
}